// This file was auto-generated by Fern from our API Definition.
export const ChannelTriggerKind = {
    Mention: "mention",
    Command: "command",
    Action: "action",
};
